export default __webpack_public_path__ + "static/media/singin-bg.0fe0046e.svg";